import { createReducer } from '@reduxjs/toolkit'

import { setLoading, setLoadingMultiple, setPrice, setPrices } from './actions'

export type TokenPrice = {
  value: number
  lastUpdate: number
  loading: boolean
}
export type TokenPriceState = {
  [key: string]: TokenPrice
}

export const initialState: TokenPriceState = {}

export default createReducer<TokenPriceState>(initialState, (builder) => {
  builder.addCase(setLoading, (state, { payload }) => {
    return {
      ...state,
      [payload.tokenId]: {
        value: state[payload.tokenId]?.value || 0,
        lastUpdate: state[payload.tokenId]?.lastUpdate || 0,
        loading: payload.loading,
      },
    }
  })
  builder.addCase(setPrice, (state, { payload }) => {
    const dateNow = Date.now()
    return {
      ...state,
      [payload.tokenId]: {
        value: payload.price,
        lastUpdate: dateNow,
        loading: false,
      },
    }
  })
  builder.addCase(setLoadingMultiple, (state, { payload }) => {
    const newState = { ...state }
    payload.tokenIds.forEach((tokenId) => {
      newState[tokenId] = {
        value: state[tokenId]?.value || 0,
        lastUpdate: state[tokenId]?.lastUpdate || 0,
        loading: payload.loading,
      }
    })
    return newState
  })
  builder.addCase(setPrices, (state, { payload }) => {
    const dateNow = Date.now()
    const newState = { ...state }
    payload.tokenIds.forEach((tokenId, index) => {
      newState[tokenId] = {
        value: payload.prices[index],
        lastUpdate: dateNow,
        loading: false,
      }
    })
    return newState
  })
})
